import styled from "styled-components";
import { type WidthProps, width } from "styled-system";
import * as CommonButton from "../../../../../../../common-deprecated/styles/lexus/Button";
import * as MonthlyPrice from "../../common/price/styles/MonthlyPrice";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";

export const CarWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: flex-start;
    width: 100%;
    padding: ${theme.space[3]}px;
    border: 1px solid ${theme.colors.grey2};

    &:nth-last-child(1),
    &:nth-last-child(2),
    &:nth-last-child(3) {
        border-top: 0;
    }

    ${MonthlyPrice.Text} {
        font-weight: bold;
    }

    @media ${getBreakpoint("up", "md")} {
        width: 50%;

        &:nth-child(even) {
            border-left: 0;
        }

        &:nth-last-child(3) {
            border-top: 1px solid ${theme.colors.grey2};
        }
    }
`;

export const PriceContainer = styled.div`
    line-height: 1.4;

    ${MonthlyPrice.Text} {
        font-size: 1.8rem;
        color: ${theme.colors.dark};
    }
`;

export const Button = styled(CommonButton.Light)`
    max-width: 100%;
    padding: 0 29px 5px 29px; /* fix to improve vertical-alignment button */
    text-overflow: ellipsis;
    overflow: hidden;
`;

export const CTAContainer = styled.div<WidthProps>`
    ${width}
    text-align: center;
`;
